import userApi from '@/request/apiList';
import storage from 'store';

// 因为默认没有路由，故拿不到路由中的参数，需要动态获取
const getHashParams = type => {
    let hash = window.location.hash;
    hash = hash.split('?');
    hash = hash[0];
    hash = hash.split('/');
    if (type == 'meeting_id') {
        return hash[hash.length - 1];
    }
    if (type == 'lang') {
        return hash[hash.length - 2];
    }
    return '';
};

export default {
    placeholder: window.$i18n.t('web.placeholder' /* 请输入内容 */),
    MENU_CONF: {
        uploadImage: {
            // server:放自己公司后端提供的图片上传接口
            server: userApi.uploadImage,
            // fieldName:自己公司和后端共同约定好的接收图片接口参数名
            fieldName: 'file',
            // 空就是所有类型
            allowedFileTypes: ['image/*'],
            // 拼接参数到地址上
            metaWithUrl: true,
            // 文件大小
            maxFileSize: 20 * 1024 * 1024,
            // 请求头
            headers: { auth: storage.get('token'), meetingID: getHashParams('meeting_id'), mid: getHashParams('meeting_id') },
            //  // 上传前
            // 上传进度的回调函数
            onProgress(progress) {
                console.log('onProgress', progress);
            },
            onBeforeUpload(file) {
                console.log(file);
                //     // file 选中的文件，格式如 { key: file }
                // let canuseFile =['jpg', 'jpeg', 'png', 'gif'];
                //     let arr = file.name.split('.');
                //     let istrue = canuseFile.indexOf(arr[arr.length - 1]);
                //     if (istrue == -1) {
                //         this.$message.warning('错误！文件格式不支持')
                //         return false
                //     }else{
                //         return true
                //     }
            },

            // 单个文件上传成功之后
            onSuccess(file, res) {
                // insertFn(result.data)
                console.log('onSuccess', file.url, res);
                //    let  fileUrl=process.env.NODE_ENV == 'development' ? config.serviceUrlDev + config.fileService : config.serviceUrlProd + config.fileService;

                //     let path=fileUrl+res.data;
                //     console.log(path)
                //     insertFn(path)
                // this.$notify({
                //     title: '操作成功',
                //     message: '上传成功',
                //     type: 'success',
                //     duration: 1000,
                //     position: 'top-left',
                // });
            },
            // 单个文件上传失败
            onFailed(file, res) {
                // console.log('onFailed', file, res)
                this.$notify({
                    title: this.$t('web.operate_fail' /* 操作失败 */),
                    message: this.$t('web.upload_fail' /* 上传失败 */),
                    type: 'warning',
                    duration: 1000,
                    position: 'top-left'
                });
            },
            // 上传错误，或者触发 timeout 超时
            onError(file, err, res) {
                // alert(err.message)
                // console.error('onError', file, err, res)
                this.$notify({
                    title: this.$t('web.operate_fail' /* 操作失败 */),
                    message: this.$t('web.upload_fail' /* 上传失败 */),
                    type: 'warning',
                    duration: 1000,
                    position: 'top-left'
                });
            },
            //重点是此方法
            customInsert(result, insertFn) {
                // result是返回的json格式
                // 从 result 中找到 url alt href ，然后插图图片
                let path = result.data.absolute_path;
                //把完整地址穿进去
                insertFn(path);
            }
        }
    }
};
